import { TabsComponentProps} from "@/types";
import {  ConditionalValue, Tabs } from "@chakra-ui/react";
import { JSX } from "react";

const TabsComponent = (props: TabsComponentProps) => {

        const children: JSX.Element[] = props.children
        const variant: ConditionalValue<"outline" | "line" | "subtle" | "enclosed" | "plain" | undefined> = props.variant
        // const labels = props.labels

        console.log(children)

        return (
        //   <Tabs.Root key="members" defaultValue="members" variant={variant}>
        //     <Tabs.List>
        //         {labels.map((label: string) => {
        //             return (
        //                 <Tabs.Trigger value="members">
        //                     {label}
        //                 </Tabs.Trigger>
        //             )
        //         })}
        //     </Tabs.List>
        //         {children.map((child: any) => {
        //             return (
        //                 <Tabs.Content value="members">
        //                     {child}
        //                     test
        //                 </Tabs.Content>
        //             )
        //         })}
        //   </Tabs.Root>

        <Tabs.Root key={"outline"} defaultValue="members" variant={variant}>
            <Tabs.List>
              <Tabs.Trigger value="members">
                Members
              </Tabs.Trigger>
              <Tabs.Trigger value="projects">
                Projects
              </Tabs.Trigger>
              <Tabs.Trigger value="tasks">
                Settings
              </Tabs.Trigger>
            </Tabs.List>
            <Tabs.Content value="members">
              Manage your team members
            </Tabs.Content>
            <Tabs.Content value="projects">Manage your projects</Tabs.Content>
            <Tabs.Content value="tasks">
              Manage your tasks for freelancers
            </Tabs.Content>
          </Tabs.Root>
        )


}

export default TabsComponent;